var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('TextAlignmentsDesktop',_vm._g(_vm._b({},'TextAlignmentsDesktop',_vm.textAlignmentsProps,false),_vm.textAlignmentsEmits)):_c('TextAlignmentsMobile',_vm._g(_vm._b({},'TextAlignmentsMobile',_vm.textAlignmentsProps,false),_vm.textAlignmentsEmits))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }